__turbopack_context__.v({
  "icon": "index-module__ywQfUG__icon",
});
